import { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

const ListPanels = lazy(() => import("@pages/ListPanels"));
const Panel = lazy(() => import("@pages/Panel"));
const PanelPresentation = lazy(() => import("@pages/PanelPresentation"));
const Login = lazy(() => import("@pages/Login"));
const Logout = lazy(() => import("@pages/Logout"));

export const router = createBrowserRouter([
  { path: "/", element: <ListPanels /> },
  { path: "/:id/presentation", element: <PanelPresentation /> },
  // Rota única do painel: `/add` casa aqui como sentinela de rascunho, então o
  // primeiro save troca só o param e a árvore do painel não é remontada.
  { path: "/:id", element: <Panel /> },
  { path: "/login", element: <Login /> },
  { path: "/logout", element: <Logout /> },
  { path: "/information", element: <Navigate to="/" replace /> },
  { path: "*", element: <Navigate to="/" replace /> },
]);
